import localization from "../../../config/localization";
import { Button } from "../../ui";

export function ChatSupportMenu() {
  const handleClick = () => {
    window.open("https://www.google.com", "_blank");
  };

  return (
    <div className="mx-4 mt-4">
         <Button
        className="need-chat-btn w-full flex items-center justify-start gap-3 px-4 py-3
          bg-[#001F3A] rounded-lg hover:bg-opacity-90 transition"
              onClick={handleClick}
          >
              <div className="icon-circle flex-shrink-0 w-8 h-8 flex items-center justify-center">
                  <img src="/icons/ic-chat.svg" alt="chat" className="w-8 h-8" />
              </div>

              <span className="help-text text-[#A0DFFF] font-medium text-base tracking-wide">
                  {localization.needhelp}
              </span>
          </Button>
    </div>
  );
}
